<script>
import { getJSON } from "lib/myAjax";

export default {
  name: "FooterComponent",
  // template location: app/concepts/footer_cpt/view/user.erb
  template: "#footer-component",
  components: {
    ContactSupport: () => import("./ContactSupport.vue"),
  },
  data() {
    return {};
  },
  computed: {
    feedBackWidth() {
      return this.isMobile ? "95%" : "80%";
    },
    feedBackHeight() {
      return this.isMobile ? "95%" : "80%";
    },
    isMobile() {
      return window.matchMedia("(max-width: 767px)").matches;
    },
    isDesktop() {
      return (
        window.matchMedia("(max-width: 1199px)").matches ||
        window.matchMedia("(min-width: 1200px)").matches
      );
    },
    currentYear() {
      return "2022";
    },
  },
  methods: {
    showFeedbackForm() {
      this.$modal.show("feedback-modal");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~styles/abstract/mixins";
@import "~styles/abstract/variables";
.logo-app {
  width: 25px;
  margin-right: 10px;
}
.footer-logo {
  width: 190px;
  img {
    width: 80px;
    height: 80px;
  }
  @include respond(max-mobile) {
    width: 285px;
    img {
      width: 60px;
      height: 60px;
    }
  }
}
.social-icon {
  width: 30px;
  height: 30px;
}
</style>

<style scoped>
.footer-logo {
  width: 80px;
  height: 80px;
}

.store-icon {
  width: 20px;
  height: 20px;
}

.social-icon {
  width: 30px;
  height: 30px;
}

@media only screen and (min-width: 1200px) {
  .footer-logo {
    width: 80px;
    height: 80px;
  }

  .store-icon {
    width: 25px;
    height: 25px;
  }

  .social-icon {
    width: 30px;
    height: 30px;
  }
}

a,
a:visited,
a:active {
  color: #f2f2f2;
}
</style>
